import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-decline-am-dialog',
    templateUrl: './decline-am-dialog.component.html',
    styleUrls: ['./decline-am-dialog.component.scss'],
    standalone: false
})
export class DeclineAmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeclineAmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }
}
